var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Grid, Tile, TileHeader, TileComment } from '../common/Tile';
import { ToolbarWithProps } from '../common/Toolbar';
import { Body } from '../root/PageRouter';
import { List, ListItemSwitch } from '@bootstraplabs/bsw-common-react';
import Loading from '../common/Loading';
export function Wizard(props) {
    // State
    var _a = React.useState([]), selected = _a[0], setSelected = _a[1];
    // Check input
    var disabled = !selected.length;
    // Event handlers
    var handleConfirm = function () { return props.onConfirm(selected); };
    var groups = props.data
        .filter(function (e) { return e.parent === null; })
        .map(function (e) { return (__assign(__assign({}, e), { categories: props.data.filter(function (child) { return child.parent === e.id; }) })); });
    var Toolbar = function () { return (_jsx(ToolbarWithProps, __assign({ action: {
            type: 'done',
            onClick: disabled ? undefined : handleConfirm,
        } }, { children: "Welcome to BootstrapWorks!" }), void 0)); };
    if (props.loading) {
        return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0), " ", _jsx(Loading, {}, void 0)] }, void 0));
    }
    return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0),
            _jsx(Body, { children: _jsx(Grid, { children: _jsxs(Tile, __assign({ span: 12 }, { children: [_jsx(TileHeader, { children: "Profile" }, void 0),
                            _jsx(TileComment, { children: "To help you get the most out of BootstrapWorks as we build out the platform, please select one or more of the options below that best describe you and your interests." }, void 0),
                            groups.map(function (group) { return (_jsxs(React.Fragment, { children: [_jsx(TileHeader, { children: group.comment }, void 0),
                                    _jsx(List, { children: group.categories.map(function (option, i) {
                                            return (_jsx(ListItemSwitch, { primary: option.comment, wrapPrimary: true, checked: selected.includes(option.id), onClick: function () {
                                                    return setSelected(selected.includes(option.id)
                                                        ? selected.filter(function (e) { return e !== option.id; })
                                                        : __spreadArrays(selected, [option.id]));
                                                } }, i));
                                        }) }, void 0)] }, group.id)); })] }), void 0) }, void 0) }, void 0)] }, void 0));
}
//# sourceMappingURL=wizard.js.map